<template>
  <div class="timelineSegment"  :class="{ active: isActive }" :style="{ width: spanWidth }"  @click.stop="jumpToYear">
    <p ref="text" :style="textStyle">{{ endYear }} to {{ startYear }}</p>
  </div>
</template>

<script>
  export default {
    name: 'Segment',
    props: ['startYear', 'endYear', 'currentYear', 'totalTimelineSpan', 'stop', 'updateYear', 'containerWidth'],
    data () {
      return {
        isActive: false,
        textStyle: {}
      }
    },
    methods: {
      jumpToYear () {
        // stop playing
        this.stop();
        this.updateYear(this.endYear);
      },
      setActiveSpan () {
        this.isActive = this.currentYear >= this.startYear && this.currentYear <= this.endYear;
      },
      adjustTextMargin () {
        if (!this.$el || !this.$refs || !this.$refs.text) {
          return;
        }
        let left = 'auto';
        // Only adjust text alignment if the text el is narrower than the segment el
        if (this.$el.clientWidth < this.$refs.text.clientWidth) {
          // If first segment, left align
          if (this.endYear == this.totalTimelineSpan.end) {
            left = 0;
          }
          // If last segment, right align
          else if (this.startYear == this.totalTimelineSpan.start) {
            left = (this.$el.clientWidth - this.$refs.text.clientWidth);
          }
          // Center text for all others
          else {
            left = (this.$el.clientWidth - this.$refs.text.clientWidth) / 2;
          }
          left += 'px';
        }
        this.textStyle = {
          marginLeft: left
        };
      }
    },
    computed: {
      span () {
        return (this.endYear + 1) - this.startYear;
      },
      spanWidth () {
        const allYears = this.totalTimelineSpan.end - this.totalTimelineSpan.start;
        const percentage = this.span / allYears;
        let width = Math.round(percentage * this.containerWidth) - 2; // Subtract 2px to account for margin-left
        width = Math.max(width, 10); // set a min to avoid any zero width segments
        return width + 'px';
      }
    },
    watch: {
      currentYear (newVal) {
        this.setActiveSpan();
      },
      spanWidth () {
        this.$nextTick(function () {
          this.adjustTextMargin();
        });
      }
    },
    mounted () {
      this.setActiveSpan();
      this.$nextTick(function () {
        this.adjustTextMargin();
      });
    }
  }
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.timelineSegment {
  flex: 1 1 auto;
  box-sizing: border-box;
  border-top: 2px solid #555;
  padding-top: 7px;
  text-align: center;
  color: $darkTextColor;
  transition: color $fastTransitionDuration, border-color $fastTransitionDuration;
  z-index: 1001; // Fix for text flicker when hovering over p text */
}

.timelineSegment + .timelineSegment {
  margin-left: 2px;
}

.timelineSegment:hover {
  cursor: pointer;
  color: $accentColor;
  border-top: 2px solid $accentColor;
  z-index: 1005;
}

.active.timelineSegment {
  color: #fff;
  border-top: 4px solid #fff;
  margin-top: -1px;
  padding-top: 6px;
}

.timelineSegment p {
  font-size: 12px;
  font-weight: $bold;
  letter-spacing: 0.25px;
  white-space: nowrap;
  opacity: 0;
  width: 75px;
  margin: 2px auto;
}
.timelineSegment:hover p,
.active.timelineSegment p {
  opacity: 1;
  transition: opacity $fastTransitionDuration;
  background: $darkBackgroundColor;
}
.timelineSegment:hover p::before,
.timelineSegment:hover p::after {
  content: ' ';
  background: $darkBackgroundColor;
  width: 3px;
  height: 1.25em;
  position: absolute;
  margin-left: -3px;
  opacity: 0.8;
}
.timelineSegment:hover p::after {
  margin-left: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Segment.vue